require("./style.scss");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({query}) {
        this.state = {
            query: query || '',
            target: false,
            active: false,
            searching: false,
            selected: null,
            filters: {},
            results: []
        };
        GState.bind(this, ['screen']);
    },
    onInput: function ({target, filters}) {
        this.setState({
            target,
            filters,
            selected: null
        });
    },
    onToggle: function (active, e) {
        this.state.active = active;
        if (!e.target.value)
            this.state.results = [];
        if (active)
            return;
        if (!e.target.value)
            return this.emit('dismiss');
        setTimeout(() => {
            this.emit('blur');
            if (!this.state.selected && this.input.facultative)
                this.emit('select', e.target.value);
        }, 300);
    },
    onKeyword: function (e) {
        this.state.query = e.target.value;
        this.state.results = [];
        if (!this.state.query || this.state.query.length < (this.input.minLength || 3))
            return this.emit('no-query');
        this.emit('query', this.state.query.replace(/\s+/, '+'));
        if (!this.state.target)
            return;
        this.emit('start');
        Array.isArray(this.state.target) ? this.state.target.map(each => this.triggerRequest(each)) : this.triggerRequest(this.state.target);
    },
    onSelect: function (index) {
        this.state.selected = index;
        this.state.query = this.input.suggestions[index][this.input.mount || 'title'];
        this.emit('select', index, this.state.results[index]);
        this.input.suggestions = [];
    },
    onSelectAlt: function (index) {
        this.emit('select-alt', index, this.input.alternatives[index]);
        this.input.suggestions = [];
    },
    triggerRequest: async function (target) {
        this.state.searching = true;
        try {
            const asFilters = !isEmpty(this.state.filters) ? `&filters=${ JSON.stringify(this.state.filters) }` : '', params = `query=${ this.state.query.replace(/\s+/, '+') }${ asFilters }`, {error, message, results} = await Request(`/${ target }/search?${ params }`);
            this.state.searching = false;
            if (error) {
                console.log('Error Searching: ', message);
                this.emit('error', '<' + target + '> Search Request Failed: ', message);
                return;
            }
            this.state.results = results;
            this.emit('result', this.state.results);
        } catch (error) {
            this.state.searching = false;
            console.log('Error Searching: ', error);
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/SearchBar/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Preloader_template = require("../Preloader/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Preloader_tag = marko_loadTag(Preloader_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Image_template = require("../Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    marko_attrs0 = {
        "class": "list-unstyled m-0"
      },
    marko_attrs1 = {
        "class": "nav-item cursor-pointer p-1"
      },
    marko_attrs2 = {
        "class": "row m-0 d-flex align-items-center"
      },
    marko_attrs3 = {
        "class": "col"
      },
    marko_attrs4 = {
        "class": "font-medium-3"
      },
    marko_attrs5 = {
        "class": "col-xl-2 col-md-2 col-3 text-center"
      },
    marko_attrs6 = {
        "class": "blue-grey-text font-small-2 m-0"
      },
    marko_attrs7 = {
        "class": "list-unstyled m-0"
      },
    marko_attrs8 = {
        "class": "nav-item cursor-pointer p-1"
      },
    marko_attrs9 = {
        "class": "row m-0 d-flex align-items-center"
      },
    marko_attrs10 = {
        "class": "col"
      },
    marko_attrs11 = {
        "class": "font-medium-3"
      },
    marko_attrs12 = {
        "class": "col-xl-2 col-md-2 col-3 text-center"
      },
    marko_attrs13 = {
        "class": "blue-grey-text font-small-2 m-0"
      },
    marko_attrs14 = {
        "class": "col-3 text-center"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": marko_classValue("position-relative w-100 zindex-" + (state.active ? 3 : 2)),
      style: marko_styleValue("height: " + (input.size == "xl" ? "65px" : state.screen.media == "xs" ? "42px" : "50px"))
    }, "0", component, null, 1);

  out.be("fieldset", {
      "class": marko_classValue("search-bar theme-bg-transparent border rounded mx-auto mb-0 overflow-hidden" + (state.active ? " active shadow" : ""))
    }, "1", component, null, 1);

  out.be("div", null, "2", component);

  out.e("input", {
      type: "text",
      "class": marko_classValue(("form-control form-control-" + (input.size || "lg")) + " pl-5 border-none shadow-none"),
      placeholder: input.placeholder || "Search ...",
      value: state.query
    }, "3", component, 0, 0, {
      onfocus: __component.d("focus", "onToggle", false, [
          true
        ]),
      onblur: __component.d("blur", "onToggle", false, [
          false
        ]),
      onkeyup: __component.d("keyup", "onKeyword", false)
    });

  if (input.icon !== false) {
    out.be("button", {
        "class": marko_classValue(("btn btn-icon " + (input.size == "xl" ? " mt-1 mr-1" : "")) + " position-absolute d-block"),
        type: "button"
      }, "4", component);

    Preloader_tag({
        class: "font-medium-5",
        active: state.searching
      }, out, __component, "5");

    if (!state.searching) {
      out.e("i", {
          "class": marko_classValue("bx " + (input.icon || "bx-search"))
        }, "6", component, 0, 1);
    }

    out.ee();
  }

  out.ee();

  out.be("div", {
      "class": marko_classValue("suggestions" + (!Array.isArray(input.suggestions) ? " d-none" : ""))
    }, "7", component, null, 1);

  if (((Array.isArray(input.alternatives) && state.active) && Array.isArray(input.suggestions)) && (!input.suggestions.length)) {
    out.be("ul", marko_attrs0, "8", component);

    var $for$0 = 0;

    marko_forOf(input.alternatives, function({ icon, title, subtitle }, index) {
      var $keyScope$0 = "[" + (($for$0++) + "]");

      out.be("li", marko_attrs1, "9" + $keyScope$0, component, null, 0, {
          onclick: __component.d("click", "onSelectAlt", false, [
              index
            ])
        });

      out.be("div", marko_attrs2, "10" + $keyScope$0, component);

      if (icon) {
        out.e("div", marko_attrs5, "11" + $keyScope$0, component, 1)
          .e("i", {
              "class": marko_classValue("font-large-1 p-1 rounded-circle theme-bg-fade bx " + icon)
            }, "12" + $keyScope$0, component, 0, 1);
      }

      out.be("div", marko_attrs3, "13" + $keyScope$0, component);

      out.e("span", marko_attrs4, "14" + $keyScope$0, component, 1)
        .t(title, component);

      if (subtitle) {
        out.e("p", marko_attrs6, "15" + $keyScope$0, component, 1)
          .t(subtitle, component);
      }

      out.ee();

      out.ee();

      out.ee();
    });

    out.ee();
  }

  if (Array.isArray(input.suggestions) && input.suggestions.length) {
    out.be("ul", marko_attrs7, "16", component);

    var $for$1 = 0;

    marko_forOf(input.suggestions, function({ poster, title, subtitle, status }, index) {
      var $keyScope$1 = "[" + (($for$1++) + "]");

      out.be("li", marko_attrs8, "17" + $keyScope$1, component, null, 0, {
          onclick: __component.d("click", "onSelect", false, [
              index
            ])
        });

      out.be("div", marko_attrs9, "18" + $keyScope$1, component);

      if (poster) {
        out.be("div", marko_attrs12, "19" + $keyScope$1, component);

        if (poster.type == "icon") {
          out.e("i", {
              "class": marko_classValue((("font-large-1 p-1 " + (poster.round ? "round" : "rounded-circle")) + " theme-bg-fade bx ") + poster.value)
            }, "20" + $keyScope$1, component, 0, 1);
        }

        if (poster.type == "image") {
          Image_tag({
              alt: "Image",
              src: poster.value,
              class: poster.round ? "round" : "rounded-circle",
              style: "width:50px"
            }, out, __component, "21" + $keyScope$1);
        }

        out.ee();
      }

      out.be("div", marko_attrs10, "22" + $keyScope$1, component);

      out.e("span", marko_attrs11, "23" + $keyScope$1, component, 1)
        .t(title, component);

      if (subtitle) {
        out.e("p", marko_attrs13, "24" + $keyScope$1, component, 1)
          .t(subtitle, component);
      }

      out.ee();

      if (status) {
        out.e("div", marko_attrs14, "25" + $keyScope$1, component, 1)
          .t(status, component);
      }

      out.ee();

      out.ee();
    });

    out.ee();
  }

  out.ee();

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
